enum ETicketDeliveryMode {
  Unknown = 0,
  Email = 1,
  SMS = 2 
}
export default ETicketDeliveryMode